import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { GET_PLC_SAFETY_TRIGGER_BY_ID } from './actionTypes';
import { getPlcSafetyTriggerByIdSuccess, getPlcSafetyTriggerByIdError } from './actions';
import { getPlcSafetyAPI } from '../../../api/plcSafety';

const plcSafetyAPI = getPlcSafetyAPI();

function* getTriggerById({ payload: { user, triggerId } }) {
  try {
    const response = yield call(plcSafetyAPI.getTriggerById, user.token, triggerId);
    yield put(getPlcSafetyTriggerByIdSuccess(response));
  } catch (error) {
    yield put(getPlcSafetyTriggerByIdError(error));
  }
}

export function* watchGetPlcSafetyTriggerById() {
  yield takeEvery(GET_PLC_SAFETY_TRIGGER_BY_ID, getTriggerById);
}

function* getPlcSafetyTriggerByIdSaga() {
  yield all([fork(watchGetPlcSafetyTriggerById)]);
}

export default getPlcSafetyTriggerByIdSaga;
